import { render, staticRenderFns } from "./MassSend.vue?vue&type=template&id=3e0c145b"
import script from "./MassSend.vue?vue&type=script&lang=js"
export * from "./MassSend.vue?vue&type=script&lang=js"
import style0 from "./MassSend.vue?vue&type=style&index=0&id=3e0c145b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports